import { getImg } from '../../utils'
import { venture, breakpoints, ventures, brandName } from '../../config'

const articleSchemaTemplate = (post) => {
  const imagesArray = []
  breakpoints.forEach((breakpoint) => {
    imagesArray.push(getImg(post.imageSlug, 25, breakpoint))
  })

  const authorName = post?.authorName ?? post?.author?.name
  return JSON.stringify({
    '@context': 'https://schema.org',
    '@type': 'NewsArticle',
    publisher: {
      name: brandName,
      url: ventures[venture].urls.url
    },
    headline: post.title,
    image: imagesArray,
    author: {
      '@type': 'Person',
      name: authorName || 'Lucy Beck'
    },
    datePublished: post.added
  })
}

export default articleSchemaTemplate
